import styled from '@emotion/styled';
import {
	FixedGridItem,
	getIconLinkHoverStyle,
	ITheme,
	StyledCardLink,
} from '../../../../../../ui';
import { StyledShowDetailsButton } from './ShowDetailsButton';
import { Color } from '../../../../../shared/styles/Color';
import themed from '../../../../../../ui/themer/themed';
import Responsive from '../../../../../../ui/utils/Responsive';
import { markdownListStyles } from '../../../../../content-sections/ui/components/markdownListStyles';

interface IStyledParkingProductCardProps {
	selected?: boolean;
	disabled?: boolean;
}

export const StyledParkingProductCard = styled(FixedGridItem)<
	IStyledParkingProductCardProps,
	ITheme
>`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	background: #fff;
	border-radius: 4px;
	box-shadow: ${themed(({ card, paper }, { selected }) =>
		selected ? paper.selected.boxShadow : card.fullyClickable.boxShadow,
	)};
	cursor: ${({ disabled }) => disabled && 'default !important'};

	${StyledCardLink} {
		font-weight: normal;
	}

	&:hover {
		box-shadow: ${themed(({ card, paper }, { selected, disabled }) =>
			selected
				? paper.selected.boxShadow
				: disabled
				? card.fullyClickable.boxShadow
				: card.fullyClickable.hover.boxShadow,
		)};
		cursor: pointer;

		${StyledCardLink} {
			${getIconLinkHoverStyle};
		}
	}
`;

export const StyledParkingProductCardHeader = styled.div`
	position: relative;

	${StyledShowDetailsButton} {
		position: absolute;
		background: ${Color.BackgroundWhite};
		border-radius: 0 4px;

		top: 0px;
		right: -1px;

		svg {
			border: 2px solid ${Color.Neutral30};
			background-color: ${Color.Neutral30};

			g {
				fill: ${Color.BackgroundWhite};
			}
		}
	}

	img {
		display: block;
		width: 100%;
		height: 175px;
		object-fit: cover;
		border-radius: 4px 4px 0 0;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		img {
			height: 118px;
		}
	}
`;

export const StyledParkingProductCardTitle = styled.h3`
	margin-bottom: 0;
	margin-right: 40px;
`;

export const StyledParkingProductCardSubtitle = styled.div<{}, ITheme>`
	padding: 8px 10px;
	border-radius: 4px;
	background: #efeff4;
	margin-top: 12px;
	font-size: 13px;
	display: flex;
	align-items: center;
	color: ${themed(({ color }) => color.text.default)};
	white-space: pre;

	svg {
		fill: ${themed(({ color }) => color.text.default)};
		margin-right: 6px;
	}
`;

export const StyledParkingProductCardContent = styled.div`
	padding: 16px;

	ul {
		margin-bottom: 0;

		li {
			padding-left: 0;
		}
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		padding-bottom: 0;

		ul {
			display: none;
		}
	}

	${markdownListStyles}
`;

export const StyledParkingProductCardFooter = styled.div`
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	padding: 16px;
	flex-direction: column;
`;
